import React from 'react';

/**
 * ChipSelector - Compact pill-shaped selector for single or multi-select.
 * Props:
 *   options: [{value, label}]
 *   value: string (single) or string[] (multi)
 *   onChange: (newValue) => void
 *   multi: boolean (default false)
 *   revealField: {value: string, placeholder: string} - shows text input when this value is selected
 *   revealValue: string - current value of the reveal field
 *   onRevealChange: (text) => void
 */
export function ChipSelector({ options, value, onChange, multi = false, revealField, revealValue, onRevealChange, label, required }) {
  const selected = multi ? (Array.isArray(value) ? value : []) : value;

  const toggle = (optValue) => {
    if (multi) {
      const arr = Array.isArray(value) ? [...value] : [];
      if (arr.includes(optValue)) {
        onChange(arr.filter(v => v !== optValue));
      } else {
        onChange([...arr, optValue]);
      }
    } else {
      onChange(value === optValue ? '' : optValue);
    }
  };

  const isSelected = (optValue) => {
    if (multi) return Array.isArray(selected) && selected.includes(optValue);
    return selected === optValue;
  };

  const showReveal = revealField && isSelected(revealField.value);

  return (
    <div>
      {label && (
        <div style={{ fontSize: '0.875rem', fontWeight: 600, color: '#374151', marginBottom: 8 }}>
          {label}{required && <span style={{ color: '#ef4444', marginLeft: 2 }}>*</span>}
        </div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {options.map(opt => (
          <button
            key={opt.value}
            type="button"
            onClick={() => toggle(opt.value)}
            data-testid={`chip-${opt.value}`}
            style={{
              padding: '6px 14px',
              borderRadius: 20,
              border: isSelected(opt.value) ? '2px solid #4A90B5' : '1.5px solid #d1d5db',
              backgroundColor: isSelected(opt.value) ? '#EBF4FA' : '#fff',
              color: isSelected(opt.value) ? '#1e6b8a' : '#4b5563',
              fontSize: '0.8125rem',
              fontWeight: isSelected(opt.value) ? 600 : 400,
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              whiteSpace: 'nowrap',
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {showReveal && (
        <input
          type="text"
          placeholder={revealField.placeholder || 'Please specify...'}
          value={revealValue || ''}
          onChange={e => onRevealChange && onRevealChange(e.target.value)}
          style={{
            marginTop: 8, width: '100%', padding: '8px 12px', borderRadius: 8,
            border: '1px solid #d1d5db', fontSize: '0.875rem',
          }}
        />
      )}
    </div>
  );
}
